import gql from 'graphql-tag';
import FieldsBookingCompleteWithMoreEmployee from 'graphql/fields/FieldsBookingCompleteWithMoreEmployee'

export default gql(`
	query employee( $guid: String!, $booking_guids: [String], $active: [String] ) {
		employee( guid: $guid ) {
			guid
			
			
			bookings( guid: $booking_guids, active: $active ) {
				${FieldsBookingCompleteWithMoreEmployee}
				
				employee_scans {
					guid
					code
					scanned_in_at
					scanned_in_through
					status
					
					timeslot{
						guid
					}
				}
			}
		}
	}
`);

